import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TwoFaType } from '../models/api/auth.model';
import { UserState } from '../reducers/user.reducer';

export const selectUser = createFeatureSelector<UserState>('user');

export const selectUserData = createSelector(selectUser, ({ data }) => data);
export const selectIsAdmin = createSelector(selectUser, (user): boolean => !!user.data?.admin);

export const selectUser2faType = createSelector(selectUser, (user): TwoFaType | null =>
  user.data ? (user.data.google2fa ? TwoFaType.GOOGLE_2FA : TwoFaType.EMAIL_2FA) : null,
);
